// One icon set for the Hub: thin duotone line icons (locked in mockups/neo-comms5.html).
// Shapes with class "f" get a soft fill of the same colour.

const P: Record<string, string> = {
  tasks: '<rect class="f" x="3" y="3" width="18" height="18" rx="4"/><path d="m8 12 3 3 5-6"/>',
  at: '<circle class="f" cx="12" cy="12" r="4"/><path d="M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-4 8"/>',
  threads: '<path class="f" d="M21 12a8 8 0 0 1-11.8 7L4 20l1.1-4.6A8 8 0 1 1 21 12Z"/><path d="M8.5 11h7M8.5 14h4"/>',
  later: '<path class="f" d="M7 3h10a1 1 0 0 1 1 1v17l-6-4-6 4V4a1 1 0 0 1 1-1Z"/>',
  unreads: '<path class="f" d="M4 13h4l2 3h4l2-3h4v5a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2Z"/><path d="M4 13 6.5 5h11L20 13"/>',
  bell: '<path class="f" d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9"/><path d="M10.3 21a1.9 1.9 0 0 0 3.4 0"/>',
  belloff: '<path d="M8.7 3A6 6 0 0 1 18 8c0 2.7.5 4.6 1.1 6M13.7 21a1.9 1.9 0 0 1-3.4 0M17 17H3s3-2 3-9a5.8 5.8 0 0 1 .3-1.9M2 2l20 20"/>',
  pin: '<path class="f" d="M9 3h6l-1 6 4 3v2H6v-2l4-3Z"/><path d="M12 14v7"/>',
  plus: '<path d="M12 5v14M5 12h14"/>',
  smile: '<circle class="f" cx="12" cy="12" r="9"/><path d="M8.5 14.5a4.5 4.5 0 0 0 7 0M9 9.5h.01M15 9.5h.01"/>',
  send: '<path d="M12 19V5M5 12l7-7 7 7"/>',
  chev: '<path d="m6 9 6 6 6-6"/>',
  more: '<path d="M5 12h.01M12 12h.01M19 12h.01" stroke-width="3"/>',
  reply: '<path class="f" d="M21 12a8 8 0 0 1-11.8 7L4 20l1.1-4.6A8 8 0 1 1 21 12Z"/>',
  task: '<rect class="f" x="3" y="3" width="18" height="18" rx="4"/><path d="M12 8v8M8 12h8"/>',
  clock: '<circle class="f" cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/>',
  link: '<path d="M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1M14 10a4 4 0 0 0-5.7 0l-3 3A4 4 0 0 0 11 18.7l1-1"/>',
  unread: '<circle class="f" cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="3" fill="currentColor"/>',
  edit: '<path class="f" d="M4 20h4L19 9l-4-4L4 16Z"/>',
  trash: '<path d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3"/>',
  bold: '<path d="M7 5h6a3.5 3.5 0 0 1 0 7H7zM7 12h7a3.5 3.5 0 0 1 0 7H7z"/>',
  italic: '<path d="M14 5h-4M14 19h-4M14 5l-4 14"/>',
  strike: '<path d="M5 12h14M16 6.5A4 4 0 0 0 12 5c-2.5 0-4 1.3-4 3 0 4 8 3 8 7.5 0 1.7-1.6 3.5-4 3.5a4.5 4.5 0 0 1-4-2"/>',
  list: '<path d="M9 6h11M9 12h11M9 18h11M4.5 6h.01M4.5 12h.01M4.5 18h.01"/>',
  olist: '<path d="M10 6h10M10 12h10M10 18h10M4 5l1.5-1v5M4 13.5a1.5 1.5 0 0 1 3 0c0 1.5-3 2-3 3.5h3"/>',
  quote: '<path d="M5 6v12M10 8h9M10 12h9M10 16h6"/>',
  code: '<path d="m9 8-4 4 4 4M15 8l4 4-4 4"/>',
  codeblock: '<rect class="f" x="3" y="4" width="18" height="16" rx="3"/><path d="m9 10-2 2 2 2M15 10l2 2-2 2"/>',
  aa: '<text x="0" y="18" font-size="17.5" font-weight="600" font-family="Inter,sans-serif" fill="currentColor" stroke="none">Aa</text>',
  search: '<circle class="f" cx="11" cy="11" r="6.5"/><path d="m20 20-4.2-4.2"/>',
  people: '<circle class="f" cx="9" cy="8" r="4"/><path d="M2 21a7 7 0 0 1 14 0M16 3.5a4 4 0 0 1 0 8M22 21a7 7 0 0 0-4-6.3"/>',
  follow: '<path class="f" d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9"/><path d="M10.3 21a1.9 1.9 0 0 0 3.4 0M12 6v5M9.5 8.5h5"/>',
  x: '<path d="M6 6l12 12M18 6 6 18"/>',
};

export type IconName = keyof typeof P;

export function Icon({ n, s = 16, className = "" }: { n: IconName; s?: number; className?: string }) {
  return <span className={`ic ${className}`} style={{ width: s, height: s }} dangerouslySetInnerHTML={{ __html: `<svg viewBox="0 0 24 24">${P[n]}</svg>` }} />;
}

export const Plus = ({ s = 14 }: { s?: number }) => <Icon n="plus" s={s} />;
export const Send = ({ s = 16 }: { s?: number }) => <Icon n="send" s={s} />;
export const Smile = ({ s = 15 }: { s?: number }) => <Icon n="smile" s={s} />;
export const Chevron = ({ s = 12 }: { s?: number }) => <Icon n="chev" s={s} />;
